import { createSlice } from "@reduxjs/toolkit";
import { getBilling } from "../reduxApi/billingReduxApi";

const billingSlice = createSlice({
    name: 'billing',
    initialState: {
    status: 'idel',
    billing: [],
    },
    reducers: {
        deletebillingAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.billing.findIndex((item) => item.billing.ROWID === id);
                if (index !== -1) {
                    state.billing.splice(index, 1);
                }
            });
        },     
        updatebillingAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.billing.findIndex((item) => item?.billing?.ROWID === action.payload.billingId)
            if (index != -1) {
                state.billing.splice(index, 1, { billing: action.payload.formData })
            }
        },
        addbillingAction: (state, action) => {
            console.log("Adding billing:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.billing.unshift({billing:temp});
          }
    },
    extraReducers: (builder) => {
        builder.addCase(getBilling.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getBilling.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing client Data",action.payload)                
                state.billing = action.payload.data.response;
            })
    }
})
export const { deletebillingAction, updatebillingAction, addbillingAction } = billingSlice.actions
export default billingSlice.reducer